export default defineNuxtRouteMiddleware((to, from) => {
  const dayjs = useDayjs()
  
  // Get date from query
  const date = to.query?.date
  const dateHasPassed = dayjs(date).isBefore(dayjs().startOf('day'))
  const dateTooFarIntoFuture = dayjs(date).isAfter(dayjs().add(6, 'days'))

  // Redirect table today filter if date not today
  if (!dayjs(date).isToday() && to.query?.altType === '3') {
    return navigateTo({
      path: to.path,
      query: {
        ...to.query,
        altType: undefined
      }
    })
  }
  
  // Redirect old dates to today
  if (dateHasPassed || dateTooFarIntoFuture) {
    return navigateTo({
      path: to.path,
      query: {
        ...to.query,
        date: undefined
      }
    })
  }
})
